import { useSearchParams } from 'next/navigation';

const FS_COUNT_QUERY = 'fs';

export const useFsCountFromQuery = (defaultValue?: number) => {
  const searchParams = useSearchParams();

  const param = searchParams.get(FS_COUNT_QUERY);
  const fsCount = param !== null ? Number.parseInt(param, 10) : null;
  // negative query values are user error, not a valid state — treat as their magnitude
  const absFsCount =
    fsCount === null || Number.isNaN(fsCount) ? null : Math.abs(fsCount);

  // cap runaway/typo'd values (e.g. ?fs=12345) to the first 3 digits
  const result =
    absFsCount !== null && String(absFsCount).length > 3
      ? Number.parseInt(String(absFsCount).slice(0, 3), 10)
      : absFsCount;

  return result ?? defaultValue ?? 0;
};
